import React, { useRef, useCallback } from 'react';
import { Plus, Minus, Maximize2, Locate } from 'lucide-react';
import MapComponent from './MapComponent';

const MapPanel = ({ layers, layerMetadata, searchLocation }) => {
  const mapComponentRef = useRef(null);

  const handleMapClick = useCallback((coordinates) => {
  }, []); // Empty deps - function never changes

  const handleZoomIn = () => {
    if (mapComponentRef.current) {
      mapComponentRef.current.zoomIn();
    }
  };

  const handleZoomOut = () => {
    if (mapComponentRef.current) {
      mapComponentRef.current.zoomOut();
    }
  };

  const handleFullscreen = () => {
    if (mapComponentRef.current) {
      mapComponentRef.current.toggleFullscreen();
    }
  };

  const handleCurrentLocation = () => {
    if (mapComponentRef.current) {
      mapComponentRef.current.goToCurrentLocation();
    }
  };

  return (
    <div className="flex-1 relative overflow-hidden">
      <MapComponent
        ref={mapComponentRef}
        layers={layers}
        layerMetadata={layerMetadata}
        onMapClick={handleMapClick}
        searchLocation={searchLocation}
      />

      {/* Map Controls - Top Right */}
      <div className="absolute top-2 md:top-4 right-2 md:right-4 flex flex-col space-y-1 md:space-y-2 z-20">
        <button
          onClick={handleZoomIn}
          className="bg-white hover:bg-gray-100 p-1.5 md:p-2 rounded shadow-lg transition-colors"
          title="Zoom In"
        >
          <Plus className="w-4 h-4 md:w-5 md:h-5 text-gray-700" />
        </button>
        <button
          onClick={handleZoomOut}
          className="bg-white hover:bg-gray-100 p-1.5 md:p-2 rounded shadow-lg transition-colors"
          title="Zoom Out"
        >
          <Minus className="w-4 h-4 md:w-5 md:h-5 text-gray-700" />
        </button>
        <button
          onClick={handleCurrentLocation}
          className="bg-white hover:bg-gray-100 p-1.5 md:p-2 rounded shadow-lg transition-colors"
          title="My Location"
        >
          <Locate className="w-4 h-4 md:w-5 md:h-5 text-gray-700" />
        </button>
      </div>

      {/* Fullscreen Button - Bottom Right */}
      <div className="absolute bottom-4 right-2 md:right-4 z-20">
        <button
          onClick={handleFullscreen}
          className="bg-white hover:bg-gray-100 p-1.5 md:p-2 rounded shadow-lg transition-colors"
          title="Fullscreen"
        >
          <Maximize2 className="w-4 h-4 md:w-5 md:h-5 text-gray-700" />
        </button>
      </div>
    </div>
  );
};

export default MapPanel;